import * as React from "react";
import { SVGProps } from "react";
export const InboxFillIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M4.5 17C4.09733 17 3.74667 16.8507 3.448 16.552C3.14933 16.2533 3 15.9027 3 15.5V4.5C3 4.08333 3.14933 3.72933 3.448 3.438C3.74667 3.146 4.09733 3 4.5 3H15.5C15.9167 3 16.2707 3.146 16.562 3.438C16.854 3.72933 17 4.08333 17 4.5V15.5C17 15.9027 16.854 16.2533 16.562 16.552C16.2707 16.8507 15.9167 17 15.5 17H4.5ZM10 13C10.4447 13 10.8267 12.8473 11.146 12.542C11.4653 12.236 11.7013 11.868 11.854 11.438C11.91 11.2847 12.0073 11.1733 12.146 11.104C12.2847 11.0347 12.4373 11 12.604 11H15.5V4.5H4.5V11H7.396C7.56267 11 7.71533 11.0347 7.854 11.104C7.99267 11.1733 8.09 11.2847 8.146 11.438C8.29867 11.868 8.53467 12.236 8.854 12.542C9.17333 12.8473 9.55533 13 10 13Z"
            fill="currentColor"
        />
    </svg>
);
InboxFillIcon.displayName = "InboxFillIcon";
